import React from "react";
import { Link } from "react-router-dom";
import { cx } from "./utils";

const tones = {
  blue: "bg-blue-50 text-blue-600 ring-blue-100",
  emerald: "bg-emerald-50 text-emerald-600 ring-emerald-100",
  amber: "bg-amber-50 text-amber-600 ring-amber-100",
  rose: "bg-rose-50 text-rose-600 ring-rose-100",
  orange: "bg-orange-50 text-orange-600 ring-orange-100",
  violet: "bg-violet-50 text-violet-600 ring-violet-100",
  slate: "bg-slate-50 text-slate-600 ring-slate-100",
};

const MetricTile = ({ title, value, helper, icon: Icon, tone = "blue", to, className = "" }) => {
  const content = (
    <div
      className={cx(
        "group rounded-3xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-xl",
        className
      )}
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-slate-500">{title}</p>
          <p className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">{value}</p>
        </div>
        {Icon ? (
          <span
            className={cx(
              "inline-flex h-12 w-12 items-center justify-center rounded-2xl ring-1",
              tones[tone] || tones.blue
            )}
          >
            <Icon className="h-6 w-6" />
          </span>
        ) : null}
      </div>
      {helper ? <p className="mt-4 text-sm text-slate-500">{helper}</p> : null}
    </div>
  );

  return to ? <Link to={to}>{content}</Link> : content;
};

export default MetricTile;
